var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRangeDuotoneLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Date_range_duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M2.5 8.33333C2.5 7.08718 2.5 6.4641 2.76795 6C2.94349 5.69596 3.19596 5.44349 3.5 5.26795C3.9641 5 4.58718 5 5.83333 5H14.1667C15.4128 5 16.0359 5 16.5 5.26795C16.804 5.44349 17.0565 5.69596 17.2321 6C17.5 6.4641 17.5 7.08718 17.5 8.33333H2.5Z",
    fill: "#F6F7F9",
    stroke: "#F6F7F9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 2.5,
    y: 5,
    width: 15,
    height: 12.5,
    rx: 2,
    stroke: "#F6F7F9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M5.83325 2.5L5.83325 5",
    stroke: "#F6F7F9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M14.1667 2.5L14.1667 5",
    stroke: "#F6F7F9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 27",
    x: 5.83325,
    y: 10,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 29",
    x: 5.83325,
    y: 13.333,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 28",
    x: 10.8333,
    y: 10,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    x: 10.8333,
    y: 13.333,
    width: 3.33333,
    height: 1.66667,
    rx: 0.5,
    fill: "#F6F7F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRangeDuotoneLight);
export default __webpack_public_path__ + "static/media/Date_range_duotone_light.dcb62f88dd03e3e1b72bb5e3a78e7f2c.svg";
export { ForwardRef as ReactComponent };